import { render, staticRenderFns } from "./QuestionListAnswerCard.vue?vue&type=template&id=227fefe4&scoped=true&"
import script from "./QuestionListAnswerCard.vue?vue&type=script&lang=js&"
export * from "./QuestionListAnswerCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionListAnswerCard.vue?vue&type=style&index=0&id=227fefe4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227fefe4",
  null
  
)

export default component.exports